import { createClient } from '@supabase/supabase-js';
import { getStoredSupabaseToken } from './supabaseAuthToken';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Opt-in per-tenant RLS (Option A). When VITE_SUPABASE_RLS_TOKEN === 'true', the
// client sends the Supabase-signed JWT minted at login (carrying `admin_id`) so
// PostgREST evaluates per-tenant RLS policies. When absent/expired we fall back
// to the anon key, preserving today's behaviour. The flag defaults OFF so the
// switch is deliberate and reversible; do not enable it until the tenant RLS
// policies have been verified on a staging/preview branch.
const rlsTokenEnabled = import.meta.env.VITE_SUPABASE_RLS_TOKEN === 'true';

const baseAuthOptions = {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
} as const;

export const supabase = rlsTokenEnabled
  ? createClient(supabaseUrl, supabaseAnonKey, {
      ...baseAuthOptions,
      accessToken: async () => getStoredSupabaseToken() ?? supabaseAnonKey,
    })
  : createClient(supabaseUrl, supabaseAnonKey, baseAuthOptions);

export function isAbortError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const e = err as { name?: string };
  return e.name === 'AbortError';
}